import { formatNumber } from "helpers/system";
import React from "react";

const TrailersTable = ({ data }) => {
    return (
        <table className="table table-sm">
            <thead>
                <tr>
                    <th>Номер прицепа</th>
                    <th>Статья расхода/дохода</th>
                    <th>Сумма</th>
                </tr>
            </thead>
            <tbody>
                {data?.length ? (
                    data.map((el, index) => {
                        return (
                            <tr key={index}>
                                <td>{el.trailerNumber}</td>
                                <td>{el.name}</td>
                                <td>
                                    {formatNumber(el.value, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </td>
                            </tr>
                        );
                    })
                ) : (
                    <tr>
                        <td colSpan={3} className="text-center">
                            Нет данных
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
};

export default TrailersTable;
